package gr.tech.GRAttestation.styles.grstyles

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import gr.tech.GRAttestation.styles.noBorder
import gr.tech.GRAttestation.util.Constants.FONT_FAMILY
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.AlignItems

/* Button Work */
val GenericButtonStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .noBorder()
            .fontSize(1.cssRem)
            .fontWeight(FontWeight.Medium)
            .fontFamily(FONT_FAMILY)
            .color(Colors.White)
            .cursor(Cursor.Pointer)
    }
    hover {
        Modifier
            .transition(Transition.all(250.ms))
            .backgroundColor(Colors.DarkGrey)
    }
}

val GenericLinkButtonStyle = CssStyle {
    base {
        Modifier
            .noBorder()
            .padding(leftRight = 16.px, topBottom = 8.px)
            .fontSize(1.cssRem)
            .borderRadius(4.px)
            .backgroundColor(Theme.Primary.rgb)
            .color(Colors.White)
            .textDecorationLine(TextDecorationLine.None)
    }
    hover {
        Modifier
            .transition(Transition.all(250.ms))
            .backgroundColor(Colors.DarkGrey)
    }
}

val DarkGreenHoverButtonStyle = CssStyle {
    base {
        Modifier
            .cursor(Cursor.Pointer)
            .color(Colors.White)
            .backgroundColor(Theme.DarkGreen.rgb)
            .transition(Transition.all(250.ms))
    }
    hover {
        Modifier
            .backgroundColor(Color.rgb(1, 46, 45))
    }
}

val DarkGreenOutlineHoverButtonStyle = CssStyle {
    base {
        Modifier
            .cursor(Cursor.Pointer)
            .color(Colors.White)
            .backgroundColor(Colors.White)
            .border(1.px, LineStyle.Solid, Theme.DarkGreen.rgb)
            .color(Theme.DarkGreen.rgb)
            .transition(Transition.all(250.ms))
    }
    hover {
        Modifier
            .backgroundColor(Colors.WhiteSmoke)
    }
}

val LoginPageButtonStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Row)
            .justifyContent(JustifyContent.Start)
            .alignItems(AlignItems.Center)
            .backgroundColor(Colors.WhiteSmoke)
            .border(1.px, LineStyle.Solid, Colors.Black)
            .borderRadius(6.px)
            .color(Colors.Black)
            .fontSize(24.px)
            .fontWeight(FontWeight.Bold)
            .textDecorationLine(TextDecorationLine.None)
            .transition(Transition.all(250.ms))
            .padding(8.px)
    }
    hover {
        Modifier
            .backgroundColor(Theme.HalfGray.rgb)
    }
}

val DefaultHorizontalStyle = Modifier
    .fillMaxWidth()

// Used inside AppStyles to overwrite default, cannot be applied directly for some reason.
val HorizontalDividerDark = CssStyle {
    base {
        DefaultHorizontalStyle
            .borderTop(1.px, LineStyle.Solid, Colors.Black)
    }
}

val DropdownLinkStyle = CssStyle {
    base {
        Modifier
            .cursor(Cursor.Pointer)
    }
}

